exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  position: relative;\n  min-height: 100%; }\n\nbody {\n  height: 100%; }\n\n.hand-symbol {\n  cursor: pointer; }\n\n.hand-symbol:hover {\n  opacity: 0.7; }\n", ""]);

// exports
